import React from 'react';

/** The supplied logo includes transparent padding, so the frame crops only that padding. */
export default function BrandLogo({ width = 190, height = 60, lightBackground = false, className = '' }) {
  return (
    <span
      className={className}
      style={{
        display: 'inline-block',
        position: 'relative',
        flexShrink: 0,
        overflow: 'hidden',
        verticalAlign: 'middle',
        width,
        height,
        background: lightBackground ? '#fff' : 'transparent',
        borderRadius: lightBackground ? 8 : 0,
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/librarydesk-logo.png`}
        alt="LibraryDesk by STUDWAY"
        width={width}
        height={Math.round(width * 339 / 736)}
        style={{ position: 'absolute', top: '50%', left: '50%', width: '100%', height: 'auto', maxWidth: 'none', transform: 'translate(-50%, -50%)' }}
      />
    </span>
  );
}
